
// import React, { createContext, useContext, useState, useRef, useEffect } from 'react';

// const ModalContext = createContext(null);

// export const ModalProvider = ({ children }) => {
//   const [modalData, setModalData] = useState({
//     isOpen: false,
//     title: '',
//     body: '',
//     iconType: '',
//     autoClose: false,
//     duration: 5000,
//   });

//   const timeoutRef = useRef(null);

//   const openModal = (data) => {
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//       timeoutRef.current = null;
//     }

//     const finalData = {
//       ...data,
//       isOpen: true,
//       autoClose: data.autoClose ?? false,
//       duration: data.duration ?? 5000,
//     };

//     setModalData(finalData);

//     if (finalData.autoClose) {
//       timeoutRef.current = setTimeout(() => {
//         closeModal();
//       }, finalData.duration);
//     }
//   };

//   const closeModal = () => {
//     setModalData((prev) => ({ ...prev, isOpen: false }));
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//       timeoutRef.current = null;
//     }
//   };

//   // 🔑 Add Escape key listener
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === 'Escape' && modalData.isOpen) {
//         closeModal();
//       }
//     };

//     window.addEventListener('keydown', handleKeyDown);

//     return () => {
//       window.removeEventListener('keydown', handleKeyDown);
//     };
//   }, [modalData.isOpen]);

//   return (
//     <ModalContext.Provider value={{ modalData, openModal, closeModal }}>
//       {children}
//     </ModalContext.Provider>
//   );
// };

// export const useModal = () => {
//   const context = useContext(ModalContext);
//   if (!context) {
//     throw new Error('useModal must be used within a ModalProvider');
//   }
//   return context;
// };


import React, { createContext, useContext, useState, useRef } from 'react';

const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const [modalData, setModalData] = useState({
    isOpen: false,
    title: '',
    body: '',
    iconType: '',
    autoClose: false,
    duration: 5000,
    onAction: null,
    actionLabel: 'Close',
  });

  const timeoutRef = useRef(null);

  const openModal = (data) => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    const finalData = {
      ...data,
      isOpen: true,
      autoClose: data.autoClose ?? false,
      duration: data.duration ?? 5000,
      onAction: data.onAction ?? null,
      actionLabel: data.actionLabel,
    };

    setModalData(finalData);

    if (finalData.autoClose) {
      timeoutRef.current = setTimeout(() => {
        closeModal();
      }, finalData.duration);
    }
  };

  const closeModal = () => {
    setModalData((prev) => ({ ...prev, isOpen: false }));
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  return (
    <ModalContext.Provider value={{ modalData, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};